import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePortalEventUrls } from "../usePortalEventUrls";
import { REQUEST_WIZARD_STEP_KEYS, type RequestStep } from "./requestWizardSteps";

export const useRequestStepNavigation = (eventId: string, requestId: string) => {
  const navigate = useNavigate();
  const portalUrls = usePortalEventUrls();
  const [searchParams] = useSearchParams();
  const rawStep = searchParams.get("step");
  const currentStep: RequestStep | null = REQUEST_WIZARD_STEP_KEYS.includes(rawStep as RequestStep)
    ? (rawStep as RequestStep)
    : null;

  useEffect(() => {
    if (!currentStep) {
      navigate(portalUrls.request.edit.go(eventId, requestId).intro);
    }
  }, [currentStep, eventId, requestId, navigate, portalUrls]);

  const navigateToStep = (step: RequestStep) => {
    navigate(portalUrls.request.edit.go(eventId, requestId)[step]);
    window.scrollTo(0, 0);
  };

  return { currentStep, navigateToStep };
};
